import React, { Component } from "react";
import { connect } from "react-redux";
import { Form, Row, Col, Button } from "react-bootstrap";
import Select from "react-select";
import "../../css/layout.css";
import {
  handleFieldChange,
  createTaskAssignment,
  resetTaskAssignee,
} from "../../store/actions/projects/projectTaskAssignmentActions";
class AssignTaskForm extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.createTaskAssignment();
  };

  render() {
    let memberOptions = [];
    let currentAssigneesIds = [];

    const projectMembers = this.props.projects.projectMembers;
    const taskAssignees = this.props.projects.taskAssignees;

    if (taskAssignees && taskAssignees.length > 0) {
      taskAssignees.forEach((taskAssignee) => {
        if (typeof taskAssignee.user !== "undefined") {
          const user = taskAssignee.user;
          if (user) {
            currentAssigneesIds.push(user.id);
          }
        }
      });
    }

    if (projectMembers) {
      memberOptions =
        projectMembers.length > 0 &&
        projectMembers
          .filter((data) => {
            if (typeof data.user !== "undefined") {
              const user = data.user;
              if (!currentAssigneesIds.includes(user.id)) {
                return data;
              }
            }

            return null;
          })
          .map((projectMember) => {
            if (typeof projectMember.user !== "undefined") {
              const user = projectMember.user;
              if (user) {
                return {
                  value: projectMember.user.id,
                  label:
                    projectMember.user.first_name +
                    " " +
                    projectMember.user.last_name,
                };
              }
            }
            return null;
          });
    }

    let selectedMemberOption = null;

    const selectedMember = this.props.projects.taskAssignee.selectedMember;
    if (typeof selectedMember !== "undefined") {
      selectedMemberOption = selectedMember;
    }

    const taskAssignee = this.props.projects.taskAssignee;

    const hours = taskAssignee?.hours || "";
    const startDate = taskAssignee?.startDate || "";
    const endDate = taskAssignee?.endDate || "";
    const targetActivity = taskAssignee?.targetActivity || "";

    return (
      <Form onSubmit={this.handleSubmit}>
        <Row>
          <Col xs={2} sm={2} md={2} lg={2} xl={2}>
            <Form.Group controlId="member">
              <Form.Label>
                Member Name <span className="text-danger">*</span>
              </Form.Label>
              <Select
                required
                placeholder="Select member"
                isMulti={false}
                options={memberOptions}
                name="member"
                value={selectedMemberOption}
                onChange={(value) => {
                  this.props.handleFieldChange(null, {
                    member: value,
                  });

                  this.props.handleFieldChange(null, {
                    selectedMember: value,
                  });
                }}
              />
            </Form.Group>
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2}>
            <Form.Group controlId="hours">
              <Form.Label>
                SLA (minutes) <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="number"
                required
                placeholder="Enter SLA"
                value={hours}
                onChange={this.props.handleFieldChange}
              />
            </Form.Group>
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2}>
            <Form.Group controlId="targetActivity">
              <Form.Label className="">
                Target Act. Per Day <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="number"
                required
                placeholder="Target Activity"
                value={targetActivity}
                onChange={this.props.handleFieldChange}
              />
            </Form.Group>
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2}>
            <Form.Group controlId="startDate">
              <Form.Label>
                Start Date <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                required
                min="2000-12-31"
                max="9999-12-31"
                value={startDate}
                onChange={this.props.handleFieldChange}
              />
            </Form.Group>
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2}>
            <Form.Group controlId="endDate">
              <Form.Label>
                End Date <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                required
                min="2000-12-31"
                max="9999-12-31"
                value={endDate}
                onChange={this.props.handleFieldChange}
              />
            </Form.Group>
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2}>
            <div className="d-flex flex-column">
              <Form.Label>&nbsp;</Form.Label>

              <Button id="btnassign" type="submit">
                Assign
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects,
});

const mapDispatchToProps = (dispatch) => {
  return {
    handleFieldChange: (...args) => dispatch(handleFieldChange(...args)),
    createTaskAssignment: () => dispatch(createTaskAssignment()),
    resetTaskAssignee: () => dispatch(resetTaskAssignee()),
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(AssignTaskForm);
